<button #button type="button" [class]="buttonClasses()" (click)="submit()">
  <div [class]="labelClasses()">{{ label() }}</div>
</button>
